// extracted by mini-css-extract-plugin
module.exports = {"secondaryText":"styles_secondaryText__3qXpO"};